module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-8.3765ed5d.jpg";